import { useState } from "react";
import Button from "./Button";
import { useTranslation } from "react-i18next";

const ContactFormPages = () => {
  const { t } = useTranslation();

  // State for form inputs
  const [formData, setFormData] = useState({
    name: "",
    entreprise: "",
    email: "",
    phonenumber: "",
    object: "",
    message: "",
  });

  // Handle input changes and update state
  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.id]: event.target.value, // Update the field dynamically
    });
  };

  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault(); // Prevents page reload
    fetch("/api/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    }).then(async (response) => {
      if (response.status !== 204) {
        const data = await response.json();
        console.error(data);
        return;
      }
      setFormData({
        name: "",
        entreprise: "",
        email: "",
        phonenumber: "",
        object: "",
        message: "",
      });
    });
  };

  return (
    <section className="flex flex-col lg:flex-row gap-5 w-full px-5">
      <div className="w-full bg-transparent mt-20 border-2 border-white rounded-xl p-5 md:p-7 lg:p-10 order-1 lg:order-2">
        <h3 className="text-2xl font-bold uppercase text-start mb-10">
          {t("contactform.subtitle2")}
        </h3>

        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 lg:grid-cols-4 gap-x-5 gap-y-10"
        >
          <div className="flex flex-col items-start col-span-1 gap-1">
            <label htmlFor="name">{t("form.name")}</label>
            <input
              id="name"
              type="text"
              required
              className="w-full rounded-lg bg-transparent border border-white p-2"
              value={formData.name}
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-col items-start col-span-1 gap-1">
            <label htmlFor="entreprise">{t("form.entreprise")}</label>
            <input
              id="entreprise"
              type="text"
              required
              className="w-full rounded-lg bg-transparent border border-white p-2"
              value={formData.entreprise}
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-col items-start col-span-1 gap-1">
            <label htmlFor="email">{t("form.email")}</label>
            <input
              id="email"
              type="email"
              required
              className="w-full rounded-lg bg-transparent border border-white p-2"
              value={formData.email}
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-col items-start col-span-1 gap-1">
            <label htmlFor="phonenumber">{t("form.phonenumber")}</label>
            <input
              id="phonenumber"
              type="tel"
              required
              className="w-full rounded-lg bg-transparent border border-white p-2"
              value={formData.phonenumber}
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-col items-start col-span-1 gap-1">
            <label htmlFor="object">{t("form.object")}</label>
            <input
              id="object"
              type="text"
              required
              className="w-full rounded-lg bg-transparent border border-white p-2"
              value={formData.object}
              onChange={handleChange}
            />
          </div>
          <div className="col-span-1 lg:col-span-3 flex flex-col items-start gap-1">
            <label htmlFor="message">{t("form.message")}</label>
            <input
              id="message"
              required
              className="w-full h-32 lg:h-fit rounded-lg bg-transparent border border-white p-2"
              value={formData.message}
              onChange={handleChange}
            />
          </div>

          <div className="col-span-1 lg:col-span-4 flex justify-end">
            <Button
              text={t("form.send")}
              type="submit"
              orientation={"north-east"}
            />
          </div>
        </form>
      </div>
    </section>
  );
};

export default ContactFormPages;
